'use client'

import PropTypes from 'prop-types'
import { DateSelection } from '@repo/ui/DateSelection'
import { formatDate } from '@repo/utils/time'
import { parseDate } from '@repo/utils/time'

export const CustomDataFieldDate = ({ value, field, onChange, size = 'small', isInlineEditMode = false }) => {
  const handleDateChange = (value) => {
    const formattedValue = value ? formatDate(value, 'yyyy-MM-dd') : null
    onChange(formattedValue)
  }

  const { minValue, maxValue } = field
  const minValueDate = parseDate(minValue, 'dd/MM/yyyy') || null
  const maxValueDate = parseDate(maxValue, 'dd/MM/yyyy') || null

  return (
    <DateSelection
      data-testid="CustomDataFieldDate"
      format="EEE d MMM yyyy"
      value={value ? new Date(value) : null}
      onChange={handleDateChange}
      label=""
      showAdornment={true}
      sx={{ width: '100%' }}
      minValue={minValueDate}
      maxValue={maxValueDate}
      size={size}
      enableTypedDdMmYyyy={true}
      isInlineEditMode={isInlineEditMode}
    />
  )
}

CustomDataFieldDate.propTypes = {
  isInlineEditMode: PropTypes.bool,
  field: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func,
  validationErrors: PropTypes.array,
  fieldTypeIsString: PropTypes.bool,
  fieldTypeIsNumber: PropTypes.bool,
  fieldTypeIsAnId: PropTypes.bool,
  size: PropTypes.string
}
